import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import BscSwap from './pages/BscSwap';
import DexConfig from './pages/DexConfig';
import DexTester from './pages/DexTester';
import { DexServiceProvider } from './contexts/DexServiceContext';
import { ThemeProvider } from './contexts/ThemeContext';
import './App.css';

/**
 * 应用程序主组件
 * 包含路由配置和全局上下文提供者
 */
function App() {
  return (
    <ThemeProvider>
      <DexServiceProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<BscSwap />} />
              <Route path="/bsc-swap" element={<BscSwap />} />
              <Route path="/dex-config" element={<DexConfig />} />
              <Route path="/dex-tester" element={<DexTester />} />
            </Route>
          </Routes>
        </Router>
      </DexServiceProvider>
    </ThemeProvider>
  );
}

export default App;
